import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {FormFields} from 'types/utils';
import {request} from 'utils/request';

import {
    CompanyDetailsFormFields,
    UrlParameterOptions,
    UserDetailsFormFields,
} from '../types';

export type CompanyDetailsFormData = FormFields<
    Partial<
        CompanyDetailsFormFields & UrlParameterOptions & UserDetailsFormFields
    >
>;

export type CreateCompanyDetailsErrorResponse = Api.Response.Failure<
    'agreedToTerms' | 'companySize' | 'numberOfEmployees' | 'partnerName'
>;

export type CreateCompanyDetailsSuccessResponse = Api.Response.Success<
    Record<string, unknown>
>;

type CreateCompanyDetailsRequest = Partial<
    CompanyDetailsFormFields & UrlParameterOptions & UserDetailsFormFields
>;

export const usePostCompanyDetails = (): UseMutationResult<
    CreateCompanyDetailsSuccessResponse,
    CreateCompanyDetailsErrorResponse,
    CreateCompanyDetailsRequest
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: (formData) =>
            request({
                formData,
                locale,
                method: 'POST',
                uri: '/api/signup/create/',
            }),
    });
};
